import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import CheckboxInputMultiple from "@/components/ui/input/CheckboxInputMultiple.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownMiltiple',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;
  const localValue = ref([]);

  const anySelectedVariant = {
    value: "any",
    label: "Any",
  };
  const any = ref([anySelectedVariant.value]);

  const text = computed(() => {
    return props.list
      .filter((item) => props.modelValue.includes(item.id))
      .map((item) => item.title);
  });

  watch(
    () => props.modelValue,
    () => {
      if (props.modelValue.length === 0) {
        any.value = [anySelectedVariant.value];
      } else {
        any.value = [];
        localValue.value = props.modelValue;
      }
    },
    { deep: true, immediate: true }
  );
  watch(
    () => localValue.value,
    () => {
      emit("update:modelValue", localValue.value);
    },
    { deep: true }
  );

  function onClose() {
    emit("close");
  }
  function anyClick() {
    localValue.value = [];
    emit("update:modelValue", localValue.value);
  }
  function update() {
    emit("update:modelValue", localValue.value);
  }

const __returned__ = { props, emit, localValue, anySelectedVariant, any, text, onClose, anyClick, update, computed, ref, watch, DropDown, CheckboxInputMultiple }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})